import React from 'react';
import { ONBOARDING_MOCK_PRODUCTS } from './fixtureProducts';
import styles from './OnboardingMocks.module.scss';

const InventorySuccessMock: React.FC = () => (
  <div className={styles.shell} aria-hidden>
    <div className={styles.chrome}>
      <span className={styles.chromeDot} />
      <span className={styles.chromeDot} />
      <span className={styles.chromeDot} />
      <span>Inventario · MayorX</span>
    </div>
    <div className={styles.body}>
      <div className={styles.toolbar}>
        <span className={styles.toolbarTitle}>Productos</span>
        <span className={styles.pill}>+ Nuevo</span>
      </div>
      {ONBOARDING_MOCK_PRODUCTS.map(p => (
        <div key={p.code} className={styles.row}>
          <img src={p.image} alt="" className={styles.thumb} />
          <div className={styles.rowMeta}>
            <div className={styles.rowName}>{p.name}</div>
            <div className={styles.rowSub}>
              {p.code} · Stock {p.stock}
            </div>
          </div>
          <div className={styles.rowRight}>{p.price}</div>
        </div>
      ))}
    </div>
  </div>
);

export default InventorySuccessMock;
